module.exports = __webpack_public_path__ + "img/exchange-alt.f979fc37.svg";